import { render, staticRenderFns } from "./handle_result.vue?vue&type=template&id=549e3ac4&scoped=true"
import script from "./handle_result.vue?vue&type=script&lang=js"
export * from "./handle_result.vue?vue&type=script&lang=js"
import style0 from "./handle_result.vue?vue&type=style&index=0&id=549e3ac4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "549e3ac4",
  null
  
)

export default component.exports